<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    Pobierz numer od użytkownika oraz krótką wiadomość w celu późniejszego kontaktu.
    <ol class="HintsTemplate__description HintsTemplate__list">
      <li>System call web pobierze numer telefonu od użytkownika.</li>
      <li>Użytkownik będzie miał możliwość pozostawienia krótkiej wiadomości tekstowej.</li>
      <li>Pozostawione wiadomości będą widoczne w zakładce <b>Połączenia</b> ze statusem: POZOSTAWIONO WIADOMOŚĆ.</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'CallbackManuallyAfterhoursBehavior',
};
</script>
